/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { theme } from "@nordcloud/gnui";
import { useEstateRecordsAccountStatusQuery } from "~/generated/graphql";
import { BrickLoader, UniversalWrap } from "~/components";
import { ROUTES } from "~/routing/routes";
import { HomepageColumn } from "../HomepageColumn";

export function AccountStats() {
  const { data, loading, error } = useEstateRecordsAccountStatusQuery();

  const accounts = data?.accounts ?? [];
  const inactiveAccounts = accounts.filter((a) => !a?.activated);

  return (
    <UniversalWrap
      loaderProps={{
        loading,
        Component: BrickLoader,
        viewBox: "0 0 5 1",
        backgroundColor: theme.color.background.ui01,
      }}
      errorProps={{ error }}
    >
      <HomepageColumn
        heading="Cloud Accounts"
        links={[
          {
            label: "Accounts",
            url: ROUTES.accounts.index,
            count: accounts.length,
          },
          {
            label: "Accounts discovered with missing access",
            url: ROUTES.accounts.index,
            count: inactiveAccounts.length,
            danger: true,
          },
        ]}
      />
    </UniversalWrap>
  );
}
